
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/faq",
      function () {
        return require("private-next-pages/about/faq.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/faq"])
      });
    }
  